import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validator, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../components/toast/toast.service';

@Component({
  templateUrl: './establish-password.component.html',
  styleUrls: ['./login-forms.scss'],
  providers: [ AuthService ]
})
export class EstablishPasswordComponent implements OnInit {
  private token: string;
  errorMessage: string;
  passwordMismatch: boolean;

  establishPasswordForm: FormGroup;

  constructor (
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private toastService: ToastService
  ) {
    this.createResetPasswordForm();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
    });
  }

  createResetPasswordForm() {
    this.establishPasswordForm = this.formBuilder.group({
      password: ['', Validators.compose([Validators.required, Validators.pattern(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z].{8,}/)])],
      confirmPassword: ['', Validators.required]
    });
  }

  get password() {
    return this.establishPasswordForm.get('password');
  }
  get confirmPassword() {
    return this.establishPasswordForm.get('confirmPassword');
  }

  validatePasswordMatch() {
    if (this.establishPasswordForm.get('password').dirty && this.establishPasswordForm.get('confirmPassword').dirty) {
      if (this.establishPasswordForm.value.password !== this.establishPasswordForm.value.confirmPassword) {
        this.passwordMismatch = true;
        return;
      }
    }

    this.passwordMismatch = false;
  }

  async savePassword() {
    this.validatePasswordMatch();
    if (this.passwordMismatch) {
      return;
    }

    try {
      await this.authService.establishNewPassword(this.establishPasswordForm.value.password, this.token);
      this.toastService.throwToast('Password saved. Please login with your new password to continue.');
      this.router.navigate(['/login']);
    }
    catch (err) {
      this.errorMessage = err.message;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/login/forms/establish-password.component.ts